import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Martín G.',
  city: 'Córdoba'
}, {
  name: 'Lucía F.',
  city: 'Rosario, Santa Fe'
}, {
  name: 'Diego P.',
  city: 'La Plata, Buenos Aires'
}, {
  name: 'Sofía R.',
  city: 'Mendoza'
}, {
  name: 'Javier M.',
  city: 'Mar del Plata, Buenos Aires'
}, {
  name: 'Nicolás A.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Camila S.',
  city: 'Salta'
}, {
  name: 'Federico L.',
  city: 'Neuquén'
}, {
  name: 'Gonzalo V.',
  city: 'Bahía Blanca, Buenos Aires'
}, {
  name: 'Andrés T.',
  city: 'Santa Fe'
}, {
  name: 'Matías D.',
  city: 'Resistencia, Chaco'
}, {
  name: 'Paula C.',
  city: 'San Juan'
}, {
  name: 'Ramiro E.',
  city: 'Posadas, Misiones'
}, {
  name: 'Hernán B.',
  city: 'Río Cuarto, Córdoba'
}, {
  name: 'Leandro O.',
  city: 'Quilmes, Buenos Aires'
}, {
  name: 'Emiliano Z.',
  city: 'Paraná, Entre Ríos'
}, {
  name: 'Cristian H.',
  city: 'San Rafael, Mendoza'
}, {
  name: 'Marcos I.',
  city: 'Comodoro Rivadavia, Chubut'
}, {
  name: 'Julián Q.',
  city: 'Villa María, Córdoba'
}, {
  name: 'Verónica N.',
  city: 'Corrientes'
}];
const MINUTES = [2, 3, 4, 6, 7, 9, 11, 13, 16, 18, 21, 24];
export function BuyerPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setIndex(i => (i + 1) % BUYERS.length);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5500);
    };
    const first = setTimeout(show, 9000);
    const interval = setInterval(show, 17000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <div aria-live="polite" className={`fixed bottom-24 left-3 z-40 w-[276px] transition-all duration-500 md:bottom-6 md:left-6 md:w-[320px] ${visible ? 'pointer-events-auto translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-21" data-mp="2ktqk9z44183k">
      <div className="relative flex items-start gap-3 rounded-xl border-2 border-[#00FF85] bg-[#000000] p-3.5 pr-8 shadow-[0_0_12px_rgba(0,255,133,0.55),0_0_30px_rgba(0,255,133,0.35),0_0_60px_rgba(0,255,133,0.18),inset_0_0_14px_rgba(0,255,133,0.12)]" data-id="element-22" data-mp="2tvzwquixvbjl">
        <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-[#00FF85] bg-[#001a0d] shadow-[0_0_10px_rgba(0,255,133,0.7),inset_0_0_10px_rgba(0,255,133,0.35)]" data-id="element-23" data-mp="37swjokvxs8v7">
          <CheckIcon className="h-5 w-5 text-[#00FF85] [filter:drop-shadow(0_0_6px_rgba(0,255,133,0.9))]" strokeWidth={3} aria-hidden="true" data-id="element-24" data-mp="3hig4vx74get8" />
        </span>
        <div className="min-w-0" data-id="element-25" data-mp="3rigs3u843f2p">
          <p className="font-display text-[11px] font-extrabold uppercase tracking-wide text-white [text-shadow:0_0_10px_rgba(255,255,255,0.35)]" data-id="element-26" data-mp="3rfkvc9802wfu">
            {buyer.name}{' '}
            <span className="font-sans font-normal normal-case tracking-normal text-white/70 [text-shadow:none]" data-id="element-27" data-mp="1atny11oim4ma">
              accedió a la Bóveda
            </span>
          </p>
          <p className="mt-0.5 truncate text-[11px] font-semibold text-[#00FF85] [text-shadow:0_0_8px_rgba(0,255,133,0.6)]" data-id="element-28" data-mp="10y4dtcjbcudd">
            {buyer.city}
          </p>
          <p className="mt-0.5 text-[10px] text-white/45" data-id="element-29" data-mp="1tm08yct8ie81">hace {minutes} minutos</p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="absolute right-2 top-2 flex h-6 w-6 items-center justify-center rounded-md text-white/45 transition-colors hover:text-[#00FF85]" data-id="element-30" data-mp="1ouqkhfjf9gxq">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-31" data-mp="2hd5oeqv9j4ht" />
        </button>
      </div>
    </div>;
}